export default __webpack_public_path__ + "static/media/Hamburger.105fd37b.svg";